import { Box, Button, Text } from "@saleor/macaw-ui-next";
import React from "react";
import { FormattedMessage } from "react-intl";

export interface SelectAllBannerProps {
  pageSelectedCount: number;
  pageRowCount: number;
  totalCount?: number | null;
  allMatchingSelected: boolean;
  onSelectAllMatching: () => void;
  onClear: () => void;
}

export const SelectAllBanner: React.FC<SelectAllBannerProps> = ({
  pageSelectedCount,
  pageRowCount,
  totalCount,
  allMatchingSelected,
  onSelectAllMatching,
  onClear,
}) => {
  const hasMoreThanPage =
    typeof totalCount === "number" && totalCount > pageRowCount;

  if (pageRowCount === 0 || pageSelectedCount !== pageRowCount) {
    return null;
  }
  if (!allMatchingSelected && !hasMoreThanPage) {
    return null;
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      gap={2}
      padding={3}
      backgroundColor="default2"
      data-test-id="select-all-banner"
    >
      <Text fontSize="bodyMedium">
        {allMatchingSelected ? (
          <FormattedMessage
            defaultMessage="All {totalCount} orders are selected."
            id="msPUVR"
            description="select all banner"
            values={{ totalCount }}
          />
        ) : (
          <FormattedMessage
            defaultMessage="All {pageRowCount} orders on this page are selected."
            id="MkCeU/"
            description="select all banner"
            values={{ pageRowCount }}
          />
        )}
      </Text>
      <Button variant="tertiary" size="small" onClick={onClear}>
        <FormattedMessage
          defaultMessage="Clear selection"
          id="alxWQV"
          description="select all banner button"
        />
      </Button>
      {!allMatchingSelected && (
        <Button variant="tertiary" size="small" onClick={onSelectAllMatching}>
          <FormattedMessage
            defaultMessage="Select all {totalCount} orders"
            id="nsUeHp"
            description="select all banner button"
            values={{ totalCount }}
          />
        </Button>
      )}
    </Box>
  );
};

SelectAllBanner.displayName = "SelectAllBanner";
